/**
 * Cash game 的四種遊戲類別 —— **單一來源**。
 *
 * ⚠️ 這份原本在 `TinyGameStats.js` 與 `TinyGameLevelDetail.js` **各有一份**，
 *    而且已經漂掉了：GameStats 那份有 `bgColor`、LevelDetail 那份沒有；
 *    2026-09-10 幫 tab 補圖示時只加在 GameStats，LevelDetail 就變成
 *    「同一組類別、一邊有 icon 一邊沒有」。這個 repo 已經因為「靠複製維持
 *    一致性」漂過好幾次（getWeekExpenses、CashflowEditCell、EnhancedNavLink），
 *    所以直接抽掉。
 *
 * 🚫 `TinyEcoBot.js` 那份**不是同一件事**，別一起收 —— 它的 key 是
 *    `ring_game` / `aof` / `mtt`（EcoBot 帳單的分類），不是這裡的級別類別。
 *
 * `icon` 是 tab 用的：四種類別沒有現成的專屬圖示，用「牌面／速度／花色／其他」
 * 的語意去分，重點是四個彼此分得開，不是要精準象形。
 */
export const GAME_TYPES = {
  NLH: {
    name: 'NLH',
    color: '#1f8ef1',
    bgColor: 'rgba(31, 142, 241, 0.1)',
    icon: 'fa fa-diamond',
  },
  AOF: {
    name: 'AOF',
    color: '#00d6b4',
    bgColor: 'rgba(0, 214, 180, 0.1)',
    icon: 'fa fa-bolt',
  },
  PLO: {
    name: 'PLO',
    color: '#fd5d93',
    bgColor: 'rgba(253, 93, 147, 0.1)',
    icon: 'fa fa-clone',
  },
  Others: {
    name: 'Others',
    color: '#f17e5d',
    bgColor: 'rgba(241, 126, 93, 0.1)',
    icon: 'fa fa-ellipsis',
  },
};

/** tab 用的順序（物件鍵序在 JS 雖然穩定，但明寫比較不會被誤改） */
export const GAME_TYPE_KEYS = ['NLH', 'AOF', 'PLO', 'Others'];

export default GAME_TYPES;
